import { useEffect, useState } from "react";
import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { columnsDataCheck } from "./variables/columnsData";
import Widget from "components/widget/Widget";
import UserTableDashboard from "views/admin/default/components/UserTableDashboard";
import tableDataCheck from "./variables/tableDataCheck.json";
import { fetchData } from "../../../services/ApiFetching";
import { MdAdminPanelSettings, MdOutlineSupportAgent, MdToday } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import { HiTicket } from "react-icons/hi2";
import { AiFillAlert } from "react-icons/ai";

const Dashboard = () => {

  const [cardCount, setCardCount] = useState({
    total_tickets: 0,
    escalated_tickets: 0,
    todays_tickets: 0,
    customer_count: 0,
    agent_count: 0,
    admin_count: 0,
  });
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const fetchCardCount = async () => {
      try {
        const data = await fetchData("dashboard/getCardCount");
        setCardCount(data);
      } catch (error) {
        console.error("Failed to fetch card count:", error);
      }
    };
    fetchCardCount();
  }, []);


  return (
    <div className="mb-5">
      {/* Card widget */}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<HiTicket className="h-6 w-6" />}
          title={"Total Tickets"}
          subtitle={cardCount.total_tickets}
        />
        <Widget
          icon={<AiFillAlert className="h-6 w-6" />}
          title={"Escalated Tickets"}
          subtitle={cardCount.escalated_tickets}
        />
        <Widget
          icon={<MdToday className="h-7 w-7" />}
          title={"Today's Tickets"}
          subtitle={cardCount.todays_tickets}
        />
        <Widget
          icon={<FaUserTie className="h-6 w-6" />}
          title={"Total Customers"}
          subtitle={cardCount.customer_count}
        />
        <Widget
          icon={<MdOutlineSupportAgent className="h-7 w-7" />}
          title={"Total Agents"}
          subtitle={cardCount.agent_count}
        />
        <Widget
          icon={<MdAdminPanelSettings className="h-7 w-7" />}
          title={"Total Admin"}
          subtitle={cardCount.admin_count}
        />
      </div>

      {/* Charts */}
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div>

      {/* Tables & Charts */}
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        {/* Check Table */}
        <div>
          <UserTableDashboard
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          />
        </div>

        {/* Traffic chart & Pie Chart */}
        <div>
          <h2 className="bg-white py-3 px-5 rounded-2xl mb-4 text-lg font-bold text-navy-700 dark:text-white">
            Select A Date To See Daily Booking Status
          </h2>
          <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
            <MiniCalendar selectedDate={selectedDate} onDateChange={setSelectedDate} />
            <PieChartCard selectedDate={selectedDate} />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
